import { Genders } from "../constants/Genders";
import { supabase } from "../supabase/supabase";
import { convertGenderFromEnum, convertGenderToEnum } from "../utils/GenderUtils";
import { Hand } from "./Hand";

interface IPlayer {
    id?: number;
    name?: string;
    status?: number; // 1 - ready, 2 - exited, 3 - removed
    gender?: Genders;
    joinTime?: number;
    image?: string;
    game?: string;
    hand?: Hand;
}

export class Player {
    id: number;
    name: string;
    status: number;
    gender: Genders;
    joinTime: number;
    image: string;
    game: string;
    hand: Hand;

    constructor(id: number, name: string, status: number, gender: Genders, joinTime: number, image: string, game: string, hand: Hand) {
        this.id = id;
        this.name = name;
        this.status = status;
        this.gender = gender;
        this.joinTime = joinTime;
        this.image = image;
        this.game = game;
        this.hand = hand;
    }

    isActive () {
        return this.status === 1;
    }

    clone () {
        return new Player(this.id, this.name, this.status, this.gender, this.joinTime, this.image, this.game, this.hand);
    }

    static fromJson(json: IPlayer) {
        return new Player(
            json.id ? json.id as number : 0,
            json.name ? json.name as string : "",
            json.status !== undefined ? json.status as number : 1,
            json.gender ? convertGenderToEnum(json.gender as number) : Genders.none,
            json.joinTime ? json.joinTime as number : 0,
            json.image ? json.image as string : "",
            json.game ? json.game as string : "",
            new Hand("", 0, "", [], 0),
        );
    }

    static async addNewPlayer(name: string, status: number, gender: Genders, joinTime: number, image: string, game: string) {
        const { data, error } = await supabase
            .from("Players")
            .insert({
                name: name,
                status: status,
                gender: convertGenderFromEnum(gender),
                joinTime: joinTime,
                image: image,
                game: game
            })
            .select(`id`);
        return this.fromJson(data![0]);
    }

    static async updatePlayerStatus(playerId: number, newStatus: number) {
        const { error } = await supabase
            .from("Players")
            .update({ status: newStatus })
            .eq("id", playerId);
    }

    static async getActivePlayersNameAndImages(gameId: string) {
        const players = [];
        const { data, error } = await supabase
            .from("Players")
            .select(`
                name,
                status,
                image
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const player = this.fromJson(data![idx]);
            if (player.isActive()) {
                players.push(player);
            }
        }

        return players;
    }

    static async getActivePlayers(gameId: string) {
        const players = [];
        const { data, error } = await supabase
            .from("Players")
            .select(`
                id,
                name,
                status,
                gender,
                joinTime,
                image
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const player = this.fromJson(data![idx]);
            if (player.isActive()) {
                players.push(player);
            }
        }

        return players;
    }
}